import { render, staticRenderFns } from "./BattleRoom.vue?vue&type=template&id=7468c6f2&scoped=true"
import script from "./BattleRoom.vue?vue&type=script&lang=ts"
export * from "./BattleRoom.vue?vue&type=script&lang=ts"
import style0 from "./BattleRoom.vue?vue&type=style&index=0&id=7468c6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7468c6f2",
  null
  
)

export default component.exports